﻿export const preventDefault = action => (state, data, ev) => {
    const evParam = ev || data;

    evParam.preventDefault();

    return action(state, data, ev);
};